// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.BC-Page.BC-Page__SyncSetting .sync-translated-content-container, .BC-Page.BC-Page__SyncSetting .sync-collections-priority-container {
  display: flex;
  gap: 16px;
  padding: 20px 0;
}

.BC-Page.BC-Page__SyncSetting .sync-translated-col-title, .BC-Page.BC-Page__SyncSetting .sync-collections-col-title {
  min-width: 308px;
  max-width: 308px;
}

.BC-Page.BC-Page__SyncSetting .sync-translated-col-title p:first-child, .BC-Page.BC-Page__SyncSetting .sync-collections-col-title p:first-child {
  margin-bottom: 2px;
}

.BC-Page.BC-Page__SyncSetting .sync-translated-col-content {
  width: 100%;
}

.BC-Page.BC-Page__SyncSetting .sync-translated-guideline {
  margin-bottom: 12px;
  color: #6D7175;
}

.BC-Page.BC-Page__SyncSetting .sync-translated-section:not(:last-child) {
  margin-bottom: 20px;
}

.BC-Page.BC-Page__SyncSetting .sync-translated-section-title {
  margin-bottom: 4px;
}

.BC-Page.BC-Page__SyncSetting .sync-translated-options {
  display: flex;
  flex-wrap: wrap;
  gap: 32px;
}

.BC-Page.BC-Page__SyncSetting .divider {
  border-bottom: 1px solid #E1E3E5;
  margin: 20px 0;
}


.BC-Page.BC-Page__SyncSetting .sync-translated-guideline-container {
  display: flex;
  align-items: baseline;
  gap: 1px;
}

.BC-Page.BC-Page__SyncSetting .sync-translated-guideline-container-label {
  display: flex;
  align-items: center;
}

.BC-Page.BC-Page__SyncSetting .sync-collections-priority-container .collections-priority-container__row-action {
  border: none;
  justify-content: center;
  display: flex;
  flex-direction: column;
  padding: 8px;
  gap: 12px;
  align-items: center;
}

.BC-Page.BC-Page__SyncSetting .sync-collections-priority-container .collections-priority-container__row-action .add {
  cursor: pointer;
  color: #1f5199;
  text-decoration: none;
}

.BC-Page.BC-Page__SyncSetting .sync-collections-priority-container .collections-priority-table_header-row {
  border: 1px solid #E1E3E5;
  background-color: #fafbfb;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 10px 16px;
  border-radius: 8px;
  font-weight: bold;
}

.BC-Page.BC-Page__SyncSetting .sync-collections-priority-container .collections-priority-table_header-action {
  display: flex;
  justify-content: space-between;
  gap: 8px;
}

.BC-Page.BC-Page__SyncSetting .sync-collections-priority-container .collections-priority-table_action > span {
  cursor: pointer;
  color: #1f5199;
  text-decoration: none;
}

.BC-Page.BC-Page__SyncSetting .sync-collections-priority-container .collections-priority-table {
  border: none !important;
}

.BC-Page.BC-Page__SyncSetting .sync-collections-priority-container .collections-priority-table .collection-priority-table_row {
  border-top: none !important;
  padding: 12px 0 0;
}

.BC-Page.BC-Page__SyncSetting .sync-collections-priority-container .collections-priority-table .collection-priority-table_item-delete-button > button {
  border: none;
}

.BC-Page.BC-Page__SyncSetting .sync-translated-section .sync-translated-option-checkbox-wrapper {
  display: flex;
  align-items: center;
  gap: 4px;
}

.BC-Page.BC-Page__SyncSetting .sync-translated-section .sync-translated-option-checkbox-skeleton-wrapper {
  display: flex;
  align-items: center;
  gap: 4px;
}

@keyframes sync-shimmer-sweep {
  0% { background-position: -400px 0; }
  100% { background-position: 400px 0; }
}

.BC-Page.BC-Page__SyncSetting .sync-collections-priority-guideline-skeleton {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-bottom: 16px;
}

.BC-Page.BC-Page__SyncSetting .sync-translated-shimmer,
.BC-Page.BC-Page__SyncSetting .sync-priority-shimmer {
  border-radius: 4px;
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 800px 100%;
  animation: sync-shimmer-sweep 1.4s ease-in-out infinite;
}

.BC-Page.BC-Page__SyncSetting .collections-priority-table_action .add {
  border: none;
  box-shadow: none;
  background: transparent;
  padding: 0;
  font: inherit;
  cursor: pointer;
  color: #2C6ECB;
  text-decoration: none;
}

.BC-Page.BC-Page__SyncSetting .collections-priority-table_action .disabled {
  pointer-events: none;
  cursor: default;
  color: #d2d5d8;
}

.BC-Page.BC-Page__SyncSetting .collections-priority-table_action .add:hover {
  background-color: transparent;
  text-decoration: underline;
}
`, "",{"version":3,"sources":["webpack://./src/styles/setting-sync.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;AACX;;AAEA;EACE,gCAAgC;EAChC,cAAc;AAChB;;;AAGA;EACE,aAAa;EACb,qBAAqB;EACrB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,uBAAuB;EACvB,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,2BAA2B;EAC3B,iBAAiB;AACnB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,KAAK,6BAA6B,EAAE;EACpC,OAAO,4BAA4B,EAAE;AACvC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,mBAAmB;AACrB;;AAEA;;EAEE,kBAAkB;EAClB,yEAAyE;EACzE,2BAA2B;EAC3B,uDAAuD;AACzD;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;EACvB,UAAU;EACV,aAAa;EACb,eAAe;EACf,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;EACpB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,6BAA6B;EAC7B,0BAA0B;AAC5B","sourcesContent":[".BC-Page.BC-Page__SyncSetting .sync-translated-content-container, .BC-Page.BC-Page__SyncSetting .sync-collections-priority-container {\n  display: flex;\n  gap: 16px;\n  padding: 20px 0;\n}\n\n.BC-Page.BC-Page__SyncSetting .sync-translated-col-title, .BC-Page.BC-Page__SyncSetting .sync-collections-col-title {\n  min-width: 308px;\n  max-width: 308px;\n}\n\n.BC-Page.BC-Page__SyncSetting .sync-translated-col-title p:first-child, .BC-Page.BC-Page__SyncSetting .sync-collections-col-title p:first-child {\n  margin-bottom: 2px;\n}\n\n.BC-Page.BC-Page__SyncSetting .sync-translated-col-content {\n  width: 100%;\n}\n\n.BC-Page.BC-Page__SyncSetting .sync-translated-guideline {\n  margin-bottom: 12px;\n  color: #6D7175;\n}\n\n.BC-Page.BC-Page__SyncSetting .sync-translated-section:not(:last-child) {\n  margin-bottom: 20px;\n}\n\n.BC-Page.BC-Page__SyncSetting .sync-translated-section-title {\n  margin-bottom: 4px;\n}\n\n.BC-Page.BC-Page__SyncSetting .sync-translated-options {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 32px;\n}\n\n.BC-Page.BC-Page__SyncSetting .divider {\n  border-bottom: 1px solid #E1E3E5;\n  margin: 20px 0;\n}\n\n\n.BC-Page.BC-Page__SyncSetting .sync-translated-guideline-container {\n  display: flex;\n  align-items: baseline;\n  gap: 1px;\n}\n\n.BC-Page.BC-Page__SyncSetting .sync-translated-guideline-container-label {\n  display: flex;\n  align-items: center;\n}\n\n.BC-Page.BC-Page__SyncSetting .sync-collections-priority-container .collections-priority-container__row-action {\n  border: none;\n  justify-content: center;\n  display: flex;\n  flex-direction: column;\n  padding: 8px;\n  gap: 12px;\n  align-items: center;\n}\n\n.BC-Page.BC-Page__SyncSetting .sync-collections-priority-container .collections-priority-container__row-action .add {\n  cursor: pointer;\n  color: #1f5199;\n  text-decoration: none;\n}\n\n.BC-Page.BC-Page__SyncSetting .sync-collections-priority-container .collections-priority-table_header-row {\n  border: 1px solid #E1E3E5;\n  background-color: #fafbfb;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 16px;\n  padding: 10px 16px;\n  border-radius: 8px;\n  font-weight: bold;\n}\n\n.BC-Page.BC-Page__SyncSetting .sync-collections-priority-container .collections-priority-table_header-action {\n  display: flex;\n  justify-content: space-between;\n  gap: 8px;\n}\n\n.BC-Page.BC-Page__SyncSetting .sync-collections-priority-container .collections-priority-table_action > span {\n  cursor: pointer;\n  color: #1f5199;\n  text-decoration: none;\n}\n\n.BC-Page.BC-Page__SyncSetting .sync-collections-priority-container .collections-priority-table {\n  border: none !important;\n}\n\n.BC-Page.BC-Page__SyncSetting .sync-collections-priority-container .collections-priority-table .collection-priority-table_row {\n  border-top: none !important;\n  padding: 12px 0 0;\n}\n\n.BC-Page.BC-Page__SyncSetting .sync-collections-priority-container .collections-priority-table .collection-priority-table_item-delete-button > button {\n  border: none;\n}\n\n.BC-Page.BC-Page__SyncSetting .sync-translated-section .sync-translated-option-checkbox-wrapper {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n}\n\n.BC-Page.BC-Page__SyncSetting .sync-translated-section .sync-translated-option-checkbox-skeleton-wrapper {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n}\n\n@keyframes sync-shimmer-sweep {\n  0% { background-position: -400px 0; }\n  100% { background-position: 400px 0; }\n}\n\n.BC-Page.BC-Page__SyncSetting .sync-collections-priority-guideline-skeleton {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  margin-bottom: 16px;\n}\n\n.BC-Page.BC-Page__SyncSetting .sync-translated-shimmer,\n.BC-Page.BC-Page__SyncSetting .sync-priority-shimmer {\n  border-radius: 4px;\n  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);\n  background-size: 800px 100%;\n  animation: sync-shimmer-sweep 1.4s ease-in-out infinite;\n}\n\n.BC-Page.BC-Page__SyncSetting .collections-priority-table_action .add {\n  border: none;\n  box-shadow: none;\n  background: transparent;\n  padding: 0;\n  font: inherit;\n  cursor: pointer;\n  color: #2C6ECB;\n  text-decoration: none;\n}\n\n.BC-Page.BC-Page__SyncSetting .collections-priority-table_action .disabled {\n  pointer-events: none;\n  cursor: default;\n  color: #d2d5d8;\n}\n\n.BC-Page.BC-Page__SyncSetting .collections-priority-table_action .add:hover {\n  background-color: transparent;\n  text-decoration: underline;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
